export default "__VITE_ASSET__DHgblxYD__"